'use client'

import { useRouter } from 'next/navigation'

import { useIsDiscountProductPage, useProduct } from '@/screens/Product/hooks/useProduct'

import { getDiscountOrderUrl } from '@/entities/catalog-discount'

import { useBooleanState } from '@/shared/lib/hooks/useBooleanState'
import { useFastOrderLink } from '@/shared/lib/hooks/useFastOrderLink'
import { Modal } from '@/shared/ui'

import { fetchDolyamePayId } from '../api/fetchDolyamePayId'

import { DolyameButton } from './dolyame-button/dolyame-button'
import { DolyameModal } from './dolyame-modal/dolyame-modal'

import cl from './style.module.scss'

export const DolyameWidget = () => {
	const router = useRouter()

	const { product } = useProduct()
	const isDiscountProductPage = useIsDiscountProductPage()
	const paymentTax = product?.PRICE?.VALUE ? Math.ceil(product.PRICE.VALUE / 4) : null
	const regularOrderLink = useFastOrderLink(product.ID)
	const { active, enable, disable } = useBooleanState()
	const handleClick = async () => {
		try {
			const { data } = await fetchDolyamePayId()
			const orderLink =
				isDiscountProductPage && product.ID != null
					? `${getDiscountOrderUrl({ ID: product.ID })}&payment=${data.PAY_ID}`
					: `${regularOrderLink}?payment=${data.PAY_ID}`

			await router.push(orderLink)
		} catch {}
	}

	return (
		<div className={cl.root}>
			<DolyameButton onClick={enable} price={paymentTax} />
			<Modal onClose={disable} isOpen={active} contentClassName={cl.content} className={cl.modal}>
				<DolyameModal onClick={handleClick} />
			</Modal>
		</div>
	)
}
